export default {
	paths: {
		main: 'src/main.ssr', // Without file extension
	},
	plugins: ['../../uvue-plugins/pinia.js', '../../uvue-plugins/apollo.js'],
	css: {
		normal: 'extract', // Or `extract`
		vue: 'inline', // Or `extract`
	},
};
